// src/Components/DeviceControlModal.jsx
import React, { useEffect, useState } from 'react';
import api from '../utils/api';                    // ✅ default import로 교체
import { MdSystemUpdateAlt } from 'react-icons/md';
import ReactDOM from 'react-dom';
import DeviceStateView from './DeviceStateView';
import DeviceControl from '../Pages/DeviceControl';
import ExcelDownloadButton from './ExcelDownloadButton';
import DeviceSettingsEditor from './DeviceSettingsEditor';
import FirmwareUploadViewr from './FirmwareUploadView'; // ✅ 펌웨어 업로드 뷰
import '../css/DeviceControlModal.css';
import DeviceTrendChart from './DeviceTrendChart';

function parseJwt(t) {
  try {
    const b64 = t.split('.')[1];
    if (!b64) return null;
    const json = decodeURIComponent(
      atob(b64.replace(/-/g, '+').replace(/_/g, '/'))
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(json);
  } catch {
    return null;
  }
}

export default function DeviceControlModal({ deviceId, onClose }) {
  const [deviceData, setDeviceData] = useState(null);
  const [isConfigMode, setIsConfigMode] = useState(false);
  const [isFirmwareMode, setIsFirmwareMode] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false); // ✅ 권한 상태

  // JWT에서 role 파싱 → admin 여부 결정
  useEffect(() => {
    const token = localStorage.getItem('accessToken');
    if (!token) { setIsAdmin(false); return; }
    const p = parseJwt(token);
    if (!p) { setIsAdmin(false); return; }

    const candidates = [
      p.roles,
      p.role,
      p.authorities,
      p.scopes,
      typeof p.scope === 'string' ? p.scope.split(' ') : p.scope,
    ].filter(Boolean);
    const flat = Array.isArray(candidates[0]) ? candidates.flat() : ([]).concat(...candidates);
    setIsAdmin(flat.some(r => String(r).toLowerCase().includes('admin')));
  }, []);

  const loadDevice = () => {
    api
      .get(`/${deviceId}`)
      .then((res) => setDeviceData(res.data))
      .catch((err) => console.error('디바이스 로드 실패', err));
  };

  useEffect(() => {
    loadDevice();
  }, [deviceId]);

  const handleOpenFirmware = () => {
    if (!isAdmin) {
      alert('권한이 없습니다. 관리자만 사용할 수 있습니다.');
      return;
    }
    setIsFirmwareMode(true);
  };

  const renderHeaderActions = () => (
    <div className="modal-actions">
      {isConfigMode && (
        <button className="modal-action" onClick={() => setIsConfigMode(false)}>
          ← 뒤로
        </button>
      )}
      {isFirmwareMode && (
        <button className="modal-action" onClick={() => setIsFirmwareMode(false)}>
          ← 뒤로
        </button>
      )}
    </div>
  );

  const modalContent = (
    <div className="modal-overlay">
      <div className="modal-container">
        <button className="modal-close" onClick={onClose}>✖</button>
        <div className="modal-header">{renderHeaderActions()}</div>

        {/* ✅ 모드별 화면 전환 */}
        {isConfigMode ? (
          <DeviceSettingsEditor
            deviceData={deviceData}
            onBack={() => setIsConfigMode(false)}
            onSaved={loadDevice}
          />
        ) : isFirmwareMode ? (
          <FirmwareUploadViewr deviceId={deviceId} />
        ) : (
          <>
            <ExcelDownloadButton deviceId={deviceId} />

            {/* 관리자 전용 펌웨어 버튼 */}
            {!isConfigMode && !isFirmwareMode && (
              <button className="modal-action" onClick={handleOpenFirmware} title="관리자 전용">
                <MdSystemUpdateAlt style={{ marginRight: '6px' }} />
                펌웨어 업데이트
              </button>
            )}

            <DeviceStateView data={deviceData} />

            <div style={{ marginTop: 16 }}>
              <DeviceTrendChart deviceId={deviceId} />
            </div>
          </>
        )}
      </div>
    </div>
  );

  return ReactDOM.createPortal(
    modalContent,
    document.getElementById('modal-root')
  );
}
